var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-render-post" },
    [
      _c(
        "div",
        {
          ref: "render-post",
          staticClass: "render-post hide-scrollbar render-post-tiktok",
          style: { fontSize: _vm.fontSize + "px" },
        },
        [
          _c("div", { staticClass: "header-app" }, [
            _vm._v("\n        Pour toi\n    "),
          ]),
          _vm.music && _vm.music.track
            ? _c("div", { staticClass: "music-pill" }, [
                _c("i", { staticClass: "fa-solid fa-music-note" }),
                _c("span", { staticClass: "music-pill-text" }, [
                  _vm._v(_vm._s(_vm.music.track.title)),
                ]),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "post-content" },
            [
              _vm.isVideoPost
                ? [
                    _c("video", {
                      ref: "video",
                      class: {
                        cover: _vm.medias[0].info.aspectRatio <= 0.5625,
                      },
                      attrs: {
                        autoplay: true,
                        loop: "",
                        playsinline: "",
                        preload: "metadata",
                        src: _vm.medias[0].url,
                        type: _vm.medias[0].type,
                      },
                      domProps: { muted: _vm.videoMuted },
                      on: { click: _vm.clickOnPost, ended: _vm.onVideoLoop },
                    }),
                    _vm.music && _vm.music.track
                      ? _c("AudioPlayer", {
                          ref: "musicAudio",
                          attrs: {
                            src: _vm.music.track.progressive_download_url,
                            start: parseInt((_vm.music.start || 0) / 1000),
                            duration: parseInt(
                              (_vm.music.duration || 15000) / 1000
                            ),
                            loop: true,
                            volume: _vm.musicVol,
                          },
                        })
                      : _vm._e(),
                  ]
                : _vm.medias.length
                ? [
                    _c(
                      "div",
                      {
                        staticClass: "carousel",
                        class: { singleMedia: _vm.medias.length == 1 },
                      },
                      [
                        _c(
                          "Carousel",
                          {
                            attrs: {
                              perPage: 1,
                              adjustableHeight: true,
                              centerMode: true,
                              paginationEnabled: true,
                              navigationEnabled: false,
                            },
                          },
                          _vm._l(_vm.medias.slice(0, 20), function (media) {
                            return _c("Slide", { key: media.id }, [
                              _c("div", { staticClass: "item" }, [
                                _c("img", { attrs: { src: media.url } }),
                              ]),
                            ])
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _c("div", { staticClass: "nav-lateral" }, [
                _c(
                  "div",
                  {
                    staticClass: "page",
                    on: {
                      click: function ($event) {
                        _vm.pages.length == 1 &&
                          _vm.openTiktokPage(_vm.pages[0])
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src:
                          _vm.pages && _vm.pages.length
                            ? _vm.pages[0].avatar
                            : "img/avatar.jpg",
                        alt: "",
                      },
                    }),
                    _vm.pages.length > 1
                      ? _c("div", { staticClass: "page count" }, [
                          _vm._v(
                            "\n                    +" +
                              _vm._s(_vm.pages.length) +
                              "\n                "
                          ),
                        ])
                      : _vm._e(),
                    _c("i", { staticClass: "fa-solid fa-plus" }),
                  ]
                ),
                _c("div", { staticClass: "like" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        height: "auto",
                        width: "auto",
                        viewBox: "0 0 24 24",
                        fill: "currentColor",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M7.5 2.25C10.5 2.25 12 4.25 12 4.25C12 4.25 13.5 2.25 16.5 2.25C20 2.25 22.5 4.99999 22.5 8.5C22.5 12.5 19.2311 16.0657 16.25 18.75C14.4095 20.4072 13 21.5 12 21.5C11 21.5 9.55051 20.3989 7.75 18.75C4.81949 16.0662 1.5 12.5 1.5 8.5C1.5 4.99999 4 2.25 7.5 2.25Z",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M2.40179 12.1998C3.58902 14.6966 5.7592 16.9269 7.74989 18.75C9.5504 20.3989 10.9999 21.5 11.9999 21.5C12.9999 21.5 14.4094 20.4072 16.2499 18.75C19.231 16.0657 22.4999 12.5 22.4999 8.49997C22.4999 8.41258 22.4983 8.32566 22.4952 8.23923C20.5671 13.6619 13.6787 18.5 11.75 18.5C10.3127 18.5 5.61087 15.8131 2.40179 12.1998Z",
                          "fill-opacity": "0.03",
                        },
                      }),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "comment" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        height: "auto",
                        width: "auto",
                        viewBox: "0 0 48 48",
                        fill: "currentColor",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          d: "M2 21.5c0-10.22 9.88-18 22-18s22 7.78 22 18c0 5.63-3.19 10.74-7.32 14.8a43.6 43.6 0 0 1-14.14 9.1A1.5 1.5 0 0 1 22.5 44v-5.04C11.13 38.4 2 31.34 2 21.5M14 25a3 3 0 1 0 0-6 3 3 0 0 0 0 6m10 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6m13-3a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
                          "clip-rule": "evenodd",
                        },
                      }),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "favori" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        height: "auto",
                        width: "auto",
                        viewBox: "0 0 24 24",
                        fill: "currentColor",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M4 4.5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v15.13a1 1 0 0 1-1.555.831l-6.167-4.12a.5.5 0 0 0-.556 0l-6.167 4.12A1 1 0 0 1 4 19.63z",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M4.032 4.144Q4 4.317 4 4.5v15.13a1 1 0 0 0 1.555.831l6.167-4.12a.5.5 0 0 1 .41-.066l-.427-.198a1.49 1.49 0 0 0-1.377.063c-.581.339-1.45.85-2.25 1.339-.59.359-1.427.695-2.187.962-.929.325-1.86-.387-1.86-1.37zm8.251 12.202 6.162 4.115A1 1 0 0 0 20 19.63V4.5a2 2 0 0 0-1.123-1.798c.21.254.334.58.33.936a117 117 0 0 1-.896 13.408c-.124.99-1.17 1.553-2.076 1.133z",
                        },
                      }),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "share" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        height: "auto",
                        width: "auto",
                        viewBox: "0 0 20 20",
                        fill: "currentColor",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M10.938 3.175a.674.674 0 0 1 1.138-.488l6.526 6.215c.574.547.554 1.47-.043 1.991l-6.505 5.676a.674.674 0 0 1-1.116-.508V13.49s-6.985-1.258-9.225 2.854c-.209.384-1.023.518-.857-1.395.692-3.52 2.106-9.017 10.082-9.017z",
                          "clip-rule": "evenodd",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "m15.754 6.212 1.295 2.59a1.12 1.12 0 0 1-.268 1.349l-5.799 5.042s-.28 1.403.562 1.403 7.578-6.174 7.578-6.174.28-.842-.561-1.684c-.843-.842-2.807-2.526-2.807-2.526",
                          "clip-rule": "evenodd",
                          opacity: ".03",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M10.937 6.23v7.297s-6.683-.942-8.777 2.246C.146 18.839.331 12.309 3.363 9.057s7.574-2.827 7.574-2.827",
                        },
                      }),
                    ]
                  ),
                ]),
              ]),
              _c("div", { staticClass: "info-post" }, [
                _c("div", { staticClass: "page" }, [
                  _c("div", { staticClass: "names" }, [
                    _vm.pages.length <= 1
                      ? _c(
                          "p",
                          {
                            staticClass: "page-name",
                            on: {
                              click: function ($event) {
                                return _vm.openTiktokPage(_vm.pages[0])
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.pages[0].name))]
                        )
                      : _vm._e(),
                  ]),
                ]),
                _vm.isVideoPost
                  ? _c("div", {
                      staticClass: "description-video",
                      class: { "cut-content": !_vm.fullContent },
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.titleTranslate + "<br />" + _vm.textTranslate
                        ),
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.toggleFullContent.apply(null, arguments)
                        },
                      },
                    })
                  : _vm._e(),
                _vm.hasPhotos
                  ? _c("div", { staticClass: "post-title" }, [
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(_vm.titleTranslate || "Titre"),
                        },
                      }),
                    ])
                  : _vm._e(),
                _vm.hasPhotos
                  ? _c("div", { staticClass: "post-description" }, [
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(_vm.textTranslate || "Description"),
                        },
                      }),
                    ])
                  : _vm._e(),
              ]),
              _c("div", {
                key: _vm.videoMuted ? "no-sound" : "sound",
                class: _vm.videoMuted ? "no-sound" : "sound",
              }),
            ],
            2
          ),
        ]
      ),
      _vm.modes.includes("addTiktokMusicMode")
        ? _c("SelectMusicTiktok", {
            attrs: {
              musicSelected: _vm.music,
              position: _vm.positionFormOverlay,
              videoDurationMs: _vm.videoDurationMs,
            },
            on: { close: _vm.closeContentOverflow },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }